import { flow } from 'lodash';

import selectBoxUrl from './selectBox.html';

class SelectBoxCtrl {
  searchQuery = '';
  isLookupOpen = false;
  searchOnFields = ['name'];
  selectionFieldName = 'name'; // field name in selected object to be displayed in selected tag area

  $onChanges({ searchableCollection, currentModel }) {
    if (searchableCollection) {
      const { currentValue } = searchableCollection;
      this.searchResults = this.search(currentValue);
    }

    if (currentModel && !currentModel.isFirstChange()) {
      this.searchResults = this.search(this.searchableCollection);
    }
  }

  search(searchableCollection) {
    const results = flow([
      this.removeChosenItemsFromSearchResults.bind(this),
      this.removeExcludedItemsFromSearchResults.bind(this),
      this.removeNoneMatchingItemsFromSearchResults.bind(this),
    ])(searchableCollection);

    return results;
  }

  removeChosenItemsFromSearchResults(searchResults) {
    if (Array.isArray(this.currentModel) && this.currentModel.length) {
      return searchResults.filter(this.filterOutAlreadyChosenItems);
    }
    return searchResults;
  }

  filterOutAlreadyChosenItems = ({ id: listItemId }) =>
    !this.currentModel.find(({ id, deleted }) => !deleted && id === listItemId);

  removeExcludedItemsFromSearchResults(searchResults) {
    if (Array.isArray(this.excludedItemIds) && this.excludedItemIds.length) {
      return searchResults.filter(({ id }) => !this.excludedItemIds.includes(id));
    }
    return searchResults;
  }

  removeNoneMatchingItemsFromSearchResults(searchResults) {
    const query = this.searchQuery.toLowerCase();
    return searchResults?.filter((item) =>
      this.searchOnFields.some(
        (fieldName) =>
          typeof item[fieldName] === 'string' && item[fieldName].toLowerCase().includes(query)
      )
    );
  }

  onSearchQueryChange() {
    this.searchResults = this.search(this.searchableCollection);
    this.isLookupOpen = true;
  }

  openLookup() {
    this.isLookupOpen = true;
  }

  closeLookup() {
    this.isLookupOpen = false;
  }

  removeSelected(selected) {
    this.onRemoveSelected({ selected });
  }
}

export default {
  templateUrl: selectBoxUrl,
  controller: SelectBoxCtrl,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    currentModel: '<',
    searchableCollection: '<',
    searchResults: '=',
    placeholder: '@',
    searchOnFields: '<?',
    selectionFieldName: '@?',
    onRemoveSelected: '&',
    excludedItemIds: '<?',
    searchQuery: '=?',
    isLookupOpen: '=?',
    hasUsedAllItems: '=?',
  },
};
